class Modal {
    constructor(modalNode) {
        this.modal = modalNode;
    }

    init() {
        if (this.modal && this.modal.id) {
            try {
                const closeBtn =
                    this.modal.querySelectorAll("button[data-close]");

                const openSelectors = document.querySelectorAll(
                    `[data-modal-open="${this.modal.id}"]`
                );

                if (openSelectors.length) {
                    openSelectors.forEach((el) => {
                        el.addEventListener("click", () => {
                            this.open();
                        });
                    });
                }

                if (closeBtn.length) {
                    closeBtn.forEach((btn) => {
                        btn.addEventListener("click", () => {
                            this.close();
                        });
                    });
                }

                overflow.addEventListener("click", () => {
                    this.close();
                });
            } catch (err) {}
        } else {
            console.error("Modal selector not found or dont exist ID");
        }
    }

    open() {
        if (this.modal) {
            this.modal.classList.add("modal-open");
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        }
    }

    close() {
        if (this.modal) {
            this.modal.classList.remove("modal-open");
            document.querySelector("html").style = "";
            document.querySelector("body").style = "";
        }
    }
}

export default Modal;
